import { scenarioCollections } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/hooks/useCustomScenario/constants'
import { getScenarioOptions } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/PreviewSettingsSidebar/CustomScenarioSettings/helpers'

import { statusLabelsByShipmentType } from './constants'

export const getShipmentStatusOptions = (type, t) => getScenarioOptions(statusLabelsByShipmentType[type], t)

export const getShipmentTypeChanges = (shipment, type) => {
  if (statusLabelsByShipmentType[type][shipment.status]) return { type }

  return { type, status: scenarioCollections.shipments.newEntry.status }
}
